import { Stage } from '~/types/Application';
import axios from './axios';

export const getValidationJs = (stage?: Stage) => {
  return axios
    .get<string>(`/stages/wizard/validation`, { params: { stage } })
    .then((res) => res.data);
};
